import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const getBackgroundColor = (variant) => {
  switch (variant) {
    case "primary":
      return (props) => props.theme.colors.primary
    case "secondary":
      return (props) => props.theme.colors.secondaryAlternative || props.theme.colors.secondary
    case "white":
      return "white"
    default:
      return (props) => props.theme.colors.lightGrey
  }
}

export const StyledCard = styled.div`
  ${({ forceMobile }) =>
    !forceMobile &&
    css`
      ${breakpoint("tablet")`
        display: grid;
        grid: auto / 10rem 1fr;
        min-height: 10rem;

    ${({ fullWidth }) =>
      !!fullWidth
        ? css`
            width: 100% !important;
          `
        : css`
            width: auto !important;
          `}
      `}
    `}

  color: ${({ theme }) => theme.colors.body};
  background-color: ${({ variant }) => getBackgroundColor(variant)};
  border-radius: 1rem;

  ${({ gridArea, forceMobile }) =>
    gridArea !== undefined &&
    !forceMobile &&
    css`
      ${breakpoint("tablet")`
      grid-area: ${gridArea};
    `}
    `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      display: flex !important;
      background-color: #fff;
      border: 1px solid #e6e6e6;
      padding: 24px;
      width: auto !important;
      flex-direction: column;
      min-height: 8rem !important;
      gap: 24px;

      ${({ featured }) =>
        featured &&
        css`
          border-radius: 16px;
          border-top: 8px solid ${({ theme }) => theme.colors.primary};
          border-right: 1px solid ${({ theme }) => theme.colors.primary};
          border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
          border-left: 1px solid ${({ theme }) => theme.colors.primary};
          background: ${({ theme }) => theme.colors.rgbaBrandLightened};
        `}

      ${({ forceMobile }) =>
        !forceMobile &&
        css`
          ${breakpoint("tablet")`
            flex-direction: row;
            align-items: center;
            align-self: stretch;
          `}
        `}
    `}
`

export const ImgContainer = styled.div`
  position: relative;
  overflow: hidden;

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      height: 294px;
      width: auto;

      ${({ forceMobile }) =>
        !forceMobile &&
        css`
          ${breakpoint("tablet")`
            min-width: 144px;
            min-height: 144px;
            width: 144px;
            height: 144px;
          `}
        `}
    `}
`

export const Img = styled.img`
  display: block;
  z-index: 2;
  border-radius: 1rem 1rem 0 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  margin: 0;
  padding: 0;
  background-color: #cccccc;

  ${({ forceMobile }) =>
    !forceMobile &&
    css`
      ${breakpoint("tablet")`
        border-radius: 1rem 0 0 1rem;
      `}
    `}

  ${({ completed }) =>
    !!completed &&
    css`
      opacity: 0.9;
    `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      border-radius: 8px !important;
    `}
`

export const ImgWrapper = styled.div`
  width: inherit;
  height: inherit;
  border-radius: 8px;
  ${({ completed }) =>
    !!completed &&
    css`
      background:
        linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
        url(<path-to-image>) lightgray 50% / cover no-repeat;
    `}
`

export const Content = styled.div`
  padding: 1rem 1rem 2rem 1rem;
  display: grid;
  place-content: center stretch;
  gap: 1rem;

  ${({ forceMobile }) =>
    !forceMobile &&
    css`
      ${breakpoint("tablet")`
        padding: 1rem;
      `}
    `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      display: flex;
      flex-direction: column;
      flex: 1 0 0;
      padding: 0 !important;
      gap: 8px;
    `}
`

export const Icon = styled(FontAwesomeIcon)`
  z-index: 3;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 4rem;

  ${({ forceMobile }) =>
    !forceMobile &&
    css`
      ${breakpoint("tablet")`
        font-size: 2rem;
      `}
    `}
`

export const ReferralContainer = styled.div`
  border-radius: 8px;
  border: 1px dashed ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.rgbaBrandLightened};
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  ${({ clickable }) =>
    clickable &&
    css`
      &:hover {
        cursor: pointer;
      }
    `}
`

export const ReferralCode = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
  text-align: center;
  font-weight: 400;
  line-height: 24px;
  margin: 0;

  svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const Url = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #999;
  background: #fff;
  padding: 12px 24px;
  width: -webkit-fill-available;
  min-width: max-content;
  text-decoration: none;
  color: #333;
  line-height: 24px;
`

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-top: 1px solid #e6e6e6;
  padding-top: 24px;
  padding-left: 0;
  width: 100%;

  ${({ forceMobile }) =>
    !forceMobile &&
    css`
      ${breakpoint("tablet")`
        border-top: 0;
        border-left: 1px solid #E6E6E6;
        padding-left: 24px;
        padding-top: 0;
        width: 240px;
      `}
    `}
`

export const UrlWrapper = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.body};
`

export const H2 = styled.h2`
  font-family: ${(props) => props.theme.fonts.body.family}, sans-serif;
  margin: 0;

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      color: #333;
      font-size: 20px;
    `}
`
